/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для страницы информации о сервисе совместных покупок для участников.
   */
  app.JPInfoView = app.View.extend({
    el: '.jp-page-wrapper',
    additionalOptions: ['currency'],
  
    run: function () {
      this.minSumTemplate = app.helpers.TemplateHelper.getTemplate('#minsum-template');
      this.minSumBlock = this.$('.js-min-sum-block');
      
      if (this.minSumBlock.length) {
        this.listenTo(this.settlement, 'sync', this.updateMinSum);
      }
      this.initCarouser();
    },
  
    /**
     * Инициализировать карусель ответов на вопросы
     */
    initCarouser: function () {
      var $el = this.$('.owl-news'),
        owlConfig = {
          dots: false,
          slideBy: 1,
          responsive: {
            0: {
              items: 1,
              nav: true
            },
            420: {
              items: 2,
              nav: true
            },
            1280: {
              items: 4,
              nav: true
            }
          },
          mouseDrag: false,
          margin: 20,
        };
      this.newsCarousel = $el.owlCarousel(owlConfig);
    },
  });
})();

}.call(window));